import { oneOf } from "decoders";

export interface SpacingProps {
  topSpacing: SpacingValues;
  anchor?: string;
}

export type SpacingValues = typeof allSpacingValues[number];

export const allSpacingValues = [
  "xxlrg",
  "xlrg",
  "lrg",
  "lrg64",
  "lrg72",
  "med",
  "sml",
  "xsml",
  "xxsml",
  "none",
] as const;

export const spacingValuesDecoder = oneOf(allSpacingValues);

export const desktop: Record<SpacingValues, number> = {
  none: 0,
  xxsml: 8,
  xsml: 16,
  sml: 24,
  med: 32,
  lrg: 48,
  lrg64: 64,
  lrg72: 72,
  xlrg: 80,
  xxlrg: 160,
};

export const tablet: Record<SpacingValues, number> = {
  none: 0,
  xxsml: 8,
  xsml: 16,
  sml: 24,
  med: 32,
  lrg: 40,
  lrg64: 64,
  lrg72: 72,
  xlrg: 64,
  xxlrg: 120,
};

export const mobile: Record<SpacingValues, number> = {
  none: 0,
  xxsml: 8,
  xsml: 16,
  sml: 24,
  med: 32,
  lrg: 40,
  lrg64: 64,
  lrg72: 72,
  xlrg: 48,
  xxlrg: 80,
};
